import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Youtube, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="dp-footer mt-16 sm:mt-24 bg-white border-t border-black/5 overflow-x-hidden">
      <div className="w-full mx-auto px-4 sm:px-6 py-10 sm:py-14 grid grid-cols-1 min-[420px]:grid-cols-2 md:grid-cols-5 gap-8 min-w-0">
        <div className="min-[420px]:col-span-2 min-w-0">
          <div className="flex items-center gap-2">
            <img src="/images/newLogo.PNG" alt="Dr. Pulse" className="w-10 h-10 object-contain" />
            <div className="text-center">
              <div className="font-extrabold text-lg">Dr. <span className="text-[#B40026]">Pulse</span></div>
              <div className="dp-script text-[10px] text-[#282832] leading-none mt-0.5">Rhythm of Care</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-[#707078] max-w-sm leading-relaxed">
            High-quality visual medical education. Educational information only — not a substitute for qualified medical advice.
          </p>
          <div className="flex gap-2 mt-5">
            {[Instagram, Linkedin, Youtube, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-[#F2F2F4] flex items-center justify-center hover:bg-[#B40026] hover:text-white transition">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="font-semibold mb-3 text-sm">Learn</div>
          <ul className="space-y-2 text-sm text-[#707078]">
            <li><Link to="/anatomy" className="hover:text-[#B40026]">Anatomy</Link></li>
            <li><Link to="/diseases" className="hover:text-[#B40026]">Diseases</Link></li>
            <li><Link to="/calculators" className="hover:text-[#B40026]">Calculators</Link></li>
            <li><Link to="/quiz" className="hover:text-[#B40026]">Quizzes</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3 text-sm">Company</div>
          <ul className="space-y-2 text-sm text-[#707078]">
            <li><a href="#" className="hover:text-[#B40026]">About</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Contact</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Editorial Policy</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Careers</a></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3 text-sm">Legal</div>
          <ul className="space-y-2 text-sm text-[#707078]">
            <li><a href="#" className="hover:text-[#B40026]">Medical Disclaimer</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Terms</a></li>
            <li><a href="#" className="hover:text-[#B40026]">Licensing</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="w-full mx-auto px-4 sm:px-6 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 min-w-0">
          <p className="text-xs text-[#707078] max-w-full">© {new Date().getFullYear()} Dr. Pulse. Educational content only — always consult a qualified healthcare professional.</p>
          <p className="text-xs text-[#707078]">Made with clinical care.</p>
        </div>
      </div>
    </footer>
  );
}
